import '@antoree/ant-ui/dist/ant_ui_compiled.css';
import 'assets/styles/globalStyles.scss';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register({
serviceWorkerRegistration.unregister();
/*
serviceWorkerRegistration.register({
  onUpdate: registration => {
    const registrationWaiting = registration.waiting;

    if (registrationWaiting) {
      registrationWaiting.postMessage({ type: 'SKIP_WAITING' });

      registrationWaiting.addEventListener('statechange', e => {
        if (registrationWaiting.state === 'activated') {
          window.location.reload();
        }
      });
    }
  },
  onReady: registration => {
    if (!('Notification' in window)) {
      // eslint-disable-next-line no-alert
      alert('This browser does not support desktop notification');
    }
    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === 'granted') {
      // If it's okay let's create a notification
      // messaging
      //   ?.getToken({
      //     vapidKey: appConfig.fcmVapidId,
      //     serviceWorkerRegistration: registration,
      //   })
      //   .then(currentToken => {
      //     console.log(`%c ${currentToken}`, 'color: red; font-weight: bold;');
      //     saveCurrentFirebaseToken(currentToken);
      //   })
      //   .catch(err => {
      //     console.error('An error occurred while retrieving token. ', err);
      //   });
      // messaging?.onMessage(payload => {
      //   console.log('Message received. ', payload);
      //   const notificationTitle = payload.notification.title;
      //   const notificationOptions = {
      //     body: payload.notification.body,
      //     icon: appConfig.appLogo,
      //   };
      //   const notification = new Notification(
      //     notificationTitle,
      //     notificationOptions,
      //   );
      //   notification.onclick = event => {
      //     event.preventDefault();
      //     notification.close();
      //   };
      //   if (navigator.serviceWorker.controller) {
      //     navigator.serviceWorker.controller.postMessage({
      //       isFreshToken: true,
      //     });
      //   }
      //   const broadcast = new BroadcastChannel('firebase-messaging-channel');
      //   broadcast.postMessage({ payload });
      // });
    }
    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        // If the user accepts, let's create a notification
        if (permission === 'granted') {
          window.location.reload();
        }
      });
    }
  },
  onSuccess: () => {},
});
});
*/
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
